"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIEmptyState = _interopRequireDefault(require("UIComponents/empty/UIEmptyState"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var BlogSettingsEmptyState =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(BlogSettingsEmptyState, _Component);

  function BlogSettingsEmptyState() {
    (0, _classCallCheck2.default)(this, BlogSettingsEmptyState);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BlogSettingsEmptyState).apply(this, arguments));
  }

  (0, _createClass2.default)(BlogSettingsEmptyState, [{
    key: "renderContent",
    value: function renderContent() {
      return _react.default.createElement("div", null, _react.default.createElement(_FormattedJSXMessage.default, {
        message: "marketing.blog.emptyState.ctaCopy_jsx",
        elements: {
          ImportLink: _UILink.default,
          CreateLink: _UIButton.default
        },
        options: {
          importHref: this.props.blogImporterRoute,
          onClickCreateBlog: this.props.onCreateBlog
        }
      }), _react.default.createElement("p", {
        className: "m-top-2"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "marketing.blog.emptyState.body"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIEmptyState.default, {
        maxWidth: 1000,
        primaryContent: this.renderContent(),
        secondaryContent: _react.default.createElement(_UIIllustration.default, {
          name: "add-on-website",
          width: "100%"
        }),
        secondaryContentWidth: 250,
        titleText: _react.default.createElement(_FormattedMessage.default, {
          message: "marketing.blog.emptyState.title"
        })
      });
    }
  }]);
  return BlogSettingsEmptyState;
}(_react.Component);

BlogSettingsEmptyState.propTypes = {
  onCreateBlog: _react.PropTypes.func.isRequired,
  blogImporterRoute: _react.PropTypes.string.isRequired
};
var _default = BlogSettingsEmptyState;
exports.default = _default;
module.exports = exports.default;